module.exports = __webpack_public_path__ + "static/media/icon-settings-ramblechat.519a9ae7.svg";